/* eslint-disable */
// @ts-nocheck
import type { Dispatch } from 'redux';
import { SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA } from '../../../../shared/constants/adPartnerConstants';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import type { AdvancedMappingEntries, ConversionValueMapping } from '../types/skadnetworkTypes';
import type { AdPartner } from '../types/adPartnerTypes';
import { mergeAppsWithBlueprints, saveAdPartner } from './AdPartnerActions';
import NotificationActions from './NotificationActions';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
const errorProvider = new ErrorProvider();
const SK_AD_NETWORK_PATH = '/v1/skadnetwork';
const GetConversionValueMapping = new ReduxAsyncAction('GET_CONVERSION_VALUE_MAPPING');
GetConversionValueMapping.registerRequest(function () {
  return dash_api.get(`${SK_AD_NETWORK_PATH}/conversion-value-mapping`).then(({ data }) => data);
});
export const GET_CONVERSION_VALUE_MAPPING = GetConversionValueMapping.constants;
export const getConversionValueMapping = GetConversionValueMapping.request;
export const UPDATE_CONVERSION_VALUE_MAPPING = 'UPDATE_CONVERSION_VALUE_MAPPING';
export function updateConversionValueMapping(updateData: AdvancedMappingEntries) {
  const conversionValueMappingUpdate = {
    type: 'update',
    conversionValue: updateData.conversionValue,
    coarseValue: updateData.coarseValue,
    eventName: updateData.eventName,
    eventAlias: updateData.eventAlias,
    lowerLimit: updateData.lowerLimit,
    upperLimit: updateData.upperLimit,
    conversionLock: updateData.conversionLock,
  };
  return {
    type: UPDATE_CONVERSION_VALUE_MAPPING,
    data: conversionValueMappingUpdate,
  };
}
export const DELETE_CONVERSION_VALUE_MAPPING = 'DELETE_CONVERSION_VALUE_MAPPING';
export function deleteConversionValueMapping(conversionValue: string) {
  const conversionValueMappingDelete = {
    type: 'delete',
    conversionValue,
  };
  return {
    type: DELETE_CONVERSION_VALUE_MAPPING,
    data: conversionValueMappingDelete,
  };
}
export const UPDATE_SK_AD_NETWORK_ENABLED_EDIT = 'UPDATE_SK_AD_NETWORK_ENABLED_EDIT';
export function updateSkAdNetworkEnabledEdit(skAdNetworkEnabledEdit: boolean) {
  return {
    type: UPDATE_SK_AD_NETWORK_ENABLED_EDIT,
    data: skAdNetworkEnabledEdit,
  };
}
export const UPDATE_ENFORCE_CONVERSION_VALUE_MAPPING_HIGHEST_VALUE = 'UPDATE_ENFORCE_CONVERSION_VALUE_MAPPING_HIGHEST_VALUE';
export function updateConversionValueMappingEnforceHighestValue(enforceHighestConversionValue: boolean) {
  return {
    type: UPDATE_ENFORCE_CONVERSION_VALUE_MAPPING_HIGHEST_VALUE,
    data: enforceHighestConversionValue,
  };
}
export const SaveSkAdNetworkConfiguration = new ReduxAsyncAction('SAVE_SK_AD_NETWORK_CONFIGURATION');
SaveSkAdNetworkConfiguration.registerRequest(function (configuration: {
  conversionValueMapping: ConversionValueMapping;
  skAdNetworkEnabled: boolean;
}) {
  return dash_api.put(SK_AD_NETWORK_PATH, configuration).then(({ data }) => data);
});
export const SAVE_SK_AD_NETWORK_CONFIGURATION = SaveSkAdNetworkConfiguration.constants;
export const saveSkAdNetworkConfiguration =
  (configuration: { conversionValueMapping: ConversionValueMapping; skAdNetworkEnabled: boolean }) =>
  async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(SaveSkAdNetworkConfiguration.request(configuration));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
export const CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES = 'CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES';
export function cancelSkAdNetworkConfigurationChanges() {
  return {
    type: CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES,
  };
}
const GetSKANAdPartners = new ReduxAsyncAction('GET_SKAN_AD_PARTNERS');
GetSKANAdPartners.registerRequest(async () => {
  const [appConfigsPayload, blueprintsPayload] = await Promise.all([
    dash_api.get(`/v1/ad-networks/app-skan`),
    dash_api.get(`/v1/ad-networks/global-skan`),
  ]);
  return {
    partners: mergeAppsWithBlueprints(appConfigsPayload.data, blueprintsPayload.data),
  };
});
export const GET_SKAN_AD_PARTNERS = GetSKANAdPartners.constants;
export const getSKANAdPartners = GetSKANAdPartners.request;
export const UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING =
  'UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING';
export const UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS =
  'UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS';
export const UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR = 'UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR';
export const UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS = 'UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS';
export function updateAdPartnersForSKANAgencyPermissions(updatedAdPartners: AdPartner[]) {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING,
    });

    try {
      await Promise.all(
        updatedAdPartners.map(async (adPartner) => {
          return dispatch(
            saveAdPartner({
              partner: adPartner,
              options: {
                withNotification: false,
              },
            })
          );
        })
      );
      dispatch({
        type: UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS,
      });
      dispatch(getSKANAdPartners());
      NotificationActions.showNotification('Successfully updated agency permissions', 'success');
    } catch (err) {
      dispatch({
        type: UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR,
      });
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
}
const FetchAvailableCampaignsForSANAdPartners = new ReduxAsyncAction('FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS');
FetchAvailableCampaignsForSANAdPartners.registerRequest(() => {
  return dash_api
    .post(`${SK_AD_NETWORK_PATH}/available-campaign-names`, {
      networks: SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA,
    })
    .then(({ data }) => data);
});
export const fetchAvailableCampaignsForSANAdPartners = FetchAvailableCampaignsForSANAdPartners.request;
export const FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS = FetchAvailableCampaignsForSANAdPartners.constants;
